<template>
    <div class="main">
        <el-dialog
            :close-on-click-modal="false"
            :title="openData.title"
            :visible.sync="openData.state"
            width="700px"
            @close="dialogClose"
        >
            <div class="content">
                <el-form
                    label-width="100px"
                    :model="formData"
                    ref="formData"
                    :rules="formDataRules"
                    :disabled="openData.title !== '新增'"
                >
                    <el-form-item label="活动名称:" prop="activityName">
                        <el-input
                            v-model="formData.activityName"
                            placeholder="请输入活动名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：">
                        <template v-if="openData.title == '新增'">
                            <el-date-picker
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                style="width: 100%"
                                v-model="formData.recTime"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="recTimeChange"
                            >
                            </el-date-picker
                        ></template>
                        <template v-else>
                            <el-input
                                style="width: 48%"
                                v-model.number="formData.beginTime"
                            ></el-input>
                            至
                            <el-input
                                style="width: 48%"
                                v-model.number="formData.endTime"
                            ></el-input
                        ></template>
                    </el-form-item>
                    <el-form-item label="积分:" prop="score">
                        <el-input
                            v-model.number="formData.score"
                            placeholder="请输入积分"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="联系人:" prop="contactName">
                        <el-input
                            v-model="formData.contactName"
                            placeholder="请输入联系人"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" prop="phone">
                        <el-input
                            type="text"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="11"
                            v-model="formData.phone"
                            placeholder="请输入联系电话"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动地点:">
                        <el-input
                            v-if="openData.title !== '新增'"
                            v-model="formData.address"
                            placeholder="活动地点"
                        ></el-input>
                        <el-button
                            style="margin-bottom: 12px"
                            v-if="openData.title == '新增'"
                            type="danger"
                            icon="el-icon-location-outline"
                            @click="location"
                            >定位到标准地址</el-button
                        >
                        <el-form-item label="" v-show="mapshow">
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item>
                                        <el-select
                                            v-model="formData.provinceId"
                                            placeholder="请选择省"
                                            @change="handleProvince"
                                            :disabled="
                                                normalInfo.orgLevel == 1 ||
                                                normalInfo.orgLevel == 2 ||
                                                normalInfo.orgLevel == 3 ||
                                                normalInfo.orgLevel == 4 ||
                                                normalInfo.orgLevel == 5 ||
                                                openData.title == '查看'
                                            "
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.cityid"
                                        placeholder="请选择市"
                                        @change="handleCity"
                                        :disabled="
                                            normalInfo.orgLevel == 2 ||
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '查看'
                                        "
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.zoneid"
                                        placeholder="请选择区"
                                        @change="handleArea"
                                        :disabled="
                                            normalInfo.orgLevel == 3 ||
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '查看'
                                        "
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.streetid"
                                        placeholder="请选择街道"
                                        :disabled="
                                            normalInfo.orgLevel == 4 ||
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '查看'
                                        "
                                        @change="streetChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                            :label="item.addName"
                                            :value="item.addCode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.shequid"
                                        :disabled="
                                            normalInfo.orgLevel == 5 ||
                                            openData.title == '查看'
                                        "
                                        @change="handleCommunityChange"
                                        placeholder="请选择社区"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.address"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <input
                                v-model.trim="formData.address"
                                :disabled="openData.title == '查看'"
                                id="tipinput"
                                class="el-input__inner"
                                :class="
                                    openData.title == '查看' ? 'innerCur' : ''
                                "
                                @focus="getMap('tipinput')"
                                placeholder="请输入关键字"
                                autocomplete="off"
                            />
                            <div class="map_container">
                                <div
                                    class="map_right"
                                    id="container"
                                    style="width: 100%; height: 300px"
                                ></div>
                            </div>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="参与人员:" prop="WorkerNmae">
                        <div>
                            <el-input
                                disabled
                                style="margin-bottom: 12px"
                                v-model="formData.WorkerNmae"
                                placeholder="请新增参与人员"
                                @clear="handleClear"
                            ></el-input>
                            <el-button
                                type="success"
                                style="border-radius: 5px"
                                icon="iconfont icon-xinzeng"
                                v-if="openData.title == '新增'"
                                @click="addperson"
                                >新增
                            </el-button>
                        </div>
                        <div v-if="certificateData.length > 0">
                            <el-table
                                :data="
                                    certificateData.slice(
                                        (certificate.pageNo - 1) *
                                            certificate.pageSize,
                                        certificate.pageNo *
                                            certificate.pageSize
                                    )
                                "
                                tooltip-effect="dark"
                                style="width: 100%; margin: 15px 0"
                                border
                            >
                                <el-table-column
                                    type="index"
                                    width="70"
                                    label="序号"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="equipmentNumber"
                                    label="档案编号"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="equipmentName"
                                    label="姓名"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="equipmentPosition"
                                    label="手机号"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                            </el-table>
                            <el-pagination
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="certificate.pageSize"
                                :current-page.sync="certificate.pageNo"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="certificateData.length"
                                @size-change="handletableDataSize"
                                @current-change="handleTableDataChange"
                            ></el-pagination>
                        </div>
                    </el-form-item>
                    <el-form-item label="活动内容:" prop="content">
                        <template v-if="openData.title == '新增'">
                            <quillEditor
                                v-model="formData.content"
                            ></quillEditor>
                        </template>
                        <template v-else>
                            <quillEditor
                                :disabled="true"
                                v-model="formData.content"
                            ></quillEditor>
                        </template>
                    </el-form-item>
                    <el-form-item label="上传图片:">
                        <el-upload
                            :show-file-list="false"
                            :action="actionUrl"
                            list-type="picture-card"
                            :limit="1"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                            :on-error="error"
                        >
                            <img
                                style="width: 148px; height: 148px"
                                v-if="formData.customerPhoto"
                                :src="formData.customerPhoto"
                                class="avatar"
                            />
                            <i
                                v-else
                                class="el-icon-plus avatar-uploader-icon"
                            ></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <el-form
                    v-if="openData.title !== '新增'"
                    label-width="100px"
                    :model="exmainData"
                    ref="exmains"
                    :rules="exmainDataRules"
                    :disabled="openData.title !== '审核'"
                >
                    <el-form-item label="审核结果" prop="auditFlag">
                        <el-radio-group v-model="exmainData.auditFlag">
                            <el-radio label="2">审核通过</el-radio>
                            <el-radio label="0">审核不通过</el-radio>
                            <el-radio label="1" v-if="openData.title == '查看'"
                                >待审核</el-radio
                            >
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核意见：" prop="opinion">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model="exmainData.opinion"
                            placeholder="请输入审核意见"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="footer">
                <el-button
                    type="primary"
                    v-if="openData.title !== '查看'"
                    @click="saveForm('formData')"
                    >确 定</el-button
                >
                <el-button @click="dialogClose('formData')">取 消</el-button>
            </div>
        </el-dialog>
        <person-open
            v-if="personState"
            :openData="personInfo"
            @cancleOpen="canclePerson"
            :communityWorkerList="formData.communityWorkerList"
        ></person-open>
    </div>
</template>
<script>
import baseURL from "@/api/baseURL"
import AMap from "AMap" // 引入高德地图
import personOpen from "./personOpen"
import request from "@/utils/request.js"
import { quillEditor } from "vue-quill-editor"
export default {
    props: ["openData"],
    components: {
        quillEditor,
        personOpen,
    },
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
            whether: false,
            personState: false,
            personInfo: {},
            certificateData: [],
            certificate: { pageNo: 1, pageSize: 10, total: 0 },
            // 图片地址
            actionUrl:
                baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
            formData: {
                activityName: "",
                beginTime: "",
                endTime: "",
                score: "",
                contactName: "",
                phone: "",
                activaddressityName: "",
                content: "",
                communityWorkerList: [],
                WorkerId: "",
                WorkerNmae: "",
                customerPhoto: "", //图片路径
            },
            // 地图显示
            mapshow: false,
            showtext: true,
            formData: {
                customerName: "",
                customerIdcard: "",
                customerBirthday: "",
                customerAge: "",
                customerSex: "",
                customerPhone: "",
                address: "",
                provinceId: "", //省
                cityid: "", //市
                zoneid: "", //区
                streetid: "", //街道
                shequid: "", //社区
                longitude: "", //经度
                latitude: "", //纬度
                address: "", //详细地址
            },
            citycode: "",
            adcode: "",
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null,
            marker: null, //地图标记点
            polygons: [],
            isMap: true,
            exmainData: {
                auditFlag: "0",
                failureReason: "",
                opinion: "",
            },
            formDataRules: {
                activityName: [
                    {
                        required: true,
                        message: "请输入活动名称",
                        trigger: "blur",
                    },
                ],

                score: [
                    {
                        required: true,
                        message: "请输入积分",
                        trigger: "blur",
                    },
                ],
                contactName: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入活动地点",
                        trigger: "blur",
                    },
                ],
                WorkerNmae: [
                    {
                        required: true,
                        message: "请输入参会人员",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入活动内容",
                        trigger: "blur",
                    },
                ],
            },
            exmainDataRules: {},
            WorkerNmaes: [],
            normalInfo: {},
        }
    },
    created() {
        this.getProvince()
        this.getOrg()
        // console.log(this.openData)
        if (this.openData.title !== "新增") {
            this.personnelList()
            this.$http
                .request({
                    url: "/ypt/orgWork/communityActivity/info/getById",
                    method: "POST",
                    data: {
                        id: this.openData.id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        console.log(res.content)
                        this.formData.activityName = res.content.activityName
                        this.formData.beginTime = res.content.beginTime
                        this.formData.endTime = res.content.endTime
                        this.formData.recTime = [
                            res.content.beginTime,
                            res.content.endTime,
                        ]
                        this.formData.score = res.content.score
                        this.formData.contactName = res.content.contactName
                        this.formData.phone = res.content.phone
                        this.formData.address = res.content.address
                        this.formData.content = res.content.content
                        // this.formData.communityWorkerList = res.content.communityWorkerList
                        this.exmainData.auditFlag = res.content.auditFlag
                        this.exmainData.opinion = res.content.opinion
                        this.exmainData.failureReason =
                            res.content.failureReason
                        this.formData.content = res.content.content
                        this.formData.customerPhoto = res.content.picture
                        this.$forceUpdate()
                    }
                })
        }
    },
    methods: {
        //清空input
        handleClear() {
            this.formData.WorkerNmae = ""
        },
        handleCommunityChange(val) {
            this.$nextTick(() => {
                this.$forceUpdate()
                // this.joinAddress()
            })
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                    if (res.code == 200) {
                        // this.getProvince()
                        this.normalInfo = res.content
                        if (this.openData.title == "新增") {
                            this.changeFirst()
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        async changeFirst() {
            let province = await this.getDistricts()
            this.provinceList = province.districtList
            if (this.normalInfo.provinceId == 0) {
                this.normalInfo.provinceId = ""
            } else {
                this.normalInfo.provinceId = String(this.normalInfo.provinceId)
                let cityList = await this.getDistricts(
                    this.normalInfo.provinceId
                )
                this.cityList = cityList.districtList
                console.log("城市", this.cityList)
            }
            if (this.normalInfo.cityId) {
                this.normalInfo.cityId = String(this.normalInfo.cityId)
                let areaList = await this.getDistricts(this.normalInfo.cityId)
                this.areaList = areaList.districtList
            } else {
                this.normalInfo.cityId = ""
            }

            if (this.normalInfo.areaId) {
                this.normalInfo.areaId = String(this.normalInfo.areaId)
                let streetList = await this.getStreetList(
                    this.normalInfo.areaId
                )
                this.streetList = streetList
            } else {
                this.normalInfo.areaId = ""
            }
            if (this.normalInfo.streetId) {
                this.normalInfo.streetId = String(this.normalInfo.streetId)
                let communityList = await this.getCommityList(
                    this.normalInfo.streetId
                )
                this.communityList = communityList
            } else {
                this.normalInfo.streetId = ""
            }
            if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
            ) {
                this.provinceList.forEach((item) => {
                    if (item.adcode == this.normalInfo.provinceId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 2) {
                this.cityList.forEach((item) => {
                    if (item.adcode == this.normalInfo.cityId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 3) {
                this.areaList.forEach((item) => {
                    if (item.adcode == this.normalInfo.areaId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
            ) {
                this.streetList.forEach((item, index) => {
                    if (item.addCode == this.normalInfo.streetId) {
                        this.formData.latitude = item.latitude
                        this.formData.longitude = item.longitude
                    }
                })
            }

            if (this.normalInfo.communityId) {
                this.normalInfo.communityId = Number(
                    this.normalInfo.communityId
                )
            } else {
                this.normalInfo.communityId = ""
            }
            this.formData.provinceId = this.normalInfo.provinceId
            this.formData.cityid = this.normalInfo.cityId
            this.formData.zoneid = this.normalInfo.areaId
            this.formData.streetid = this.normalInfo.streetId
            this.formData.shequid = this.normalInfo.communityId
            this.potintMap()
            this.$forceUpdate()
            // console.log(this.normalInfo, "机构信息",this.)
        },
        // 打点
        potintMap() {
            console.log(this.formData.longitude, this.formData.latitude, "地址")
            var map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 8,
                // zooms: [3, 20],
                expandZoomRange: true,
                center: [
                    Number(this.formData.longitude),
                    Number(this.formData.latitude),
                ],
            })
            var marker = new AMap.Marker({
                position: [
                    Number(this.formData.longitude),
                    Number(this.formData.latitude),
                ],
                map: map,
            })
            map.setFitView(marker)
        },
        getMap(input) {
            const self = this
            const autoOptions = {
                city: self.formData.zoneid,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formData.address = e.poi.name
                self.formData.longitude = e.poi.location.lng
                self.formData.latitude = e.poi.location.lat
                console.log(e.poi.location, "地址")
                self.potintMap()
            })
        },
        async streetChange(val) {
            this.formData.shequid = ""
            let communityList = await this.getCommityList(val)
            console.log(communityList, "社区列表")
            this.communityList = communityList
            this.joinAddress()
        },
        // 获取参与人员
        personnelList() {
            this.$http
                .request({
                    url: "ypt/orgWork/communityActivity/info/findPersonListByActivityId",
                    method: "POST",
                    data: {
                        id: this.openData.id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        console.log(res.content.communityWorkerList)
                        let val = res.content.communityWorkerList
                        for (let i = 0; i < val.length; i++) {
                            const element1 = val[i].name
                            this.WorkerNmaes.push(element1)
                        }
                        this.formData.WorkerNmae = this.WorkerNmaes.toString()
                    }
                })
        },
        // 人员分页
        handletableDataSize(val) {
            this.certificate.pageSize = val
        },
        handleTableDataChange(val) {
            this.certificate.pageNo = val
        },
        // 选择人员
        canclePerson(val) {
            console.log(val)
            this.formData.communityWorkerList = []
            this.WorkerNmaes = []
            for (let i = 0; i < val.length; i++) {
                const element = val[i]
                this.formData.communityWorkerList.push({ id: element.id })
                this.WorkerNmaes.push(element.customerName)
            }
            console.log(this.formData.communityWorkerList)
            this.formData.WorkerNmae = this.WorkerNmaes.toString()
            this.personState = false
        },
        // 新增人员
        addperson() {
            // this.formData.communityWorkerList = []
            // this.WorkerNmaes = []
            this.personState = true
            this.personInfo = Object.assign(this.openData, {
                personState: true,
            })
            console.log()
        },
        // 上传前
        beforeAvatarUpload(file) {
            console.log(file)
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return
            }
        },
        //加载地图
        loadmap(index) {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map(index, {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },
        // 地图显示
        location() {
            this.mapshow = !this.mapshow
            if (this.openData.title == "新增") {
                this.changeFirst()
            } else {
                setTimeout(async () => {
                    await this.$nextTick(() => this.loadmap("container"))
                }, 30)
            }
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            try {
                                self.myMap.remove(self.polygons)
                            } catch (error) {
                                console.log("移除地图编辑出错了")
                            }
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                console.log(result)
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    console.log(e)
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.formData.address =
                                                        address
                                                    self.formData.longitude =
                                                        lnglat.lng
                                                    self.formData.latitude =
                                                        lnglat.lat
                                                    self.adcode =
                                                        result.regeocode.addressComponent.adcode
                                                    self.citycode =
                                                        result.regeocode.addressComponent.citycode
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })
                                    self.myMap.add(self.polygons)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (params.longitude && params.latitude) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.longitude,
                                            params.latitude,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.cityid = ""
            this.formData.zoneid = ""
            this.formData.streetid = ""
            this.formData.shequid = ""
            this.formData.address = ""
            let city = await this.getDistrict(val)
            console.log(city.districtList, val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.zoneid = ""
            this.formData.streetid = ""
            this.formData.shequid = ""
            this.formData.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.formData.streetid = ""
            this.formData.shequid = ""
            this.formData.address = ""
            // val = val.replace(/.$/, "");
            let street = await this.getStreetList(val)
            this.streetList = street
        },

        async showlist1(e) {
            console.log(this.formData.subsidyWay)
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params, {
                ...e,
                isEnable: this.formData.subsidyWay,
            })
            await request({
                url: "/ypt/admin/subsidyLevel/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                this.subsidyLevelOptions = res.content.list
            })
        },
        handleAvatarSuccess(res) {
            console.log(res)
            this.$set(this.formData, "customerPhoto", res.content)
        },
        //活动时间发生变化
        recTimeChange(val) {
            if (!val) return
            this.formData.beginTime = val[0]
            this.formData.endTime = val[1]
        },
        // 确定
        saveForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let url = ""
                    let params = {}
                    if (!this.formData.beginTime) {
                        this.$message.warning("请输入活动开始时间")
                        return false
                    }
                    if (!this.formData.endTime) {
                        this.$message.warning("请输入活动结束时间")
                        return false
                    }
                    if (!this.formData.provinceId) {
                        this.$message.warning("请输入省")
                        return false
                    }
                    if (!this.formData.cityid) {
                        this.$message.warning("请输入市")
                        return false
                    }
                    if (!this.formData.zoneid) {
                        this.$message.warning("请输入区")
                        return false
                    }
                    if (!this.formData.streetid) {
                        this.$message.warning("请输入街道")
                        return false
                    }
                    if (!this.formData.shequid) {
                        this.$message.warning("请输入社区")
                        return false
                    }
                    if (!this.formData.address) {
                        this.$message.warning("请输入关键字")
                        return false
                    }
                    if (this.openData.title === "新增") {
                        url =
                            "/ypt/orgWork/communityActivity/info/insertOrUpdate"
                        params = {
                            activityName: this.formData.activityName,
                            beginTime: this.formData.beginTime,
                            endTime: this.formData.endTime,
                            score: this.formData.score,
                            contactName: this.formData.contactName,
                            phone: this.formData.phone,
                            address: this.formData.address,
                            content: this.formData.content,
                            communityWorkerList:
                                this.formData.communityWorkerList,
                            shengId: this.formData.provinceId,
                            shiId: this.formData.citycode,
                            quId: this.formData.adcode,
                            jiedaoId: this.formData.streetid,
                            longitude: this.formData.longitude,
                            latitude: this.formData.latitude,
                            address: this.formData.address,
                            picture: this.formData.customerPhoto,
                        }
                    } else if (this.openData.title === "审核") {
                        let activityFlag = ""
                        if (this.exmainData.auditFlag == 2) {
                            activityFlag == 1
                        } else if (this.exmainData.auditFlag == 0) {
                            activityFlag == 2
                        }
                        url = "/ypt/orgWork/communityActivity/info/audit"
                        params = {
                            id: this.openData.id,
                            auditFlag: this.exmainData.auditFlag,
                            opinion: this.exmainData.opinion,
                            activityFlag: this.activityFlag,
                        }
                    }
                    this.$http
                        .request({
                            url,
                            method: "POST",
                            data: params,
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success("操作成功")
                                this.$emit("getList")
                                this.dialogClose()
                            }
                        })
                } else {
                    return false
                }
            })
        },
        // 取消
        dialogClose(formName) {
            console.log(111)
            this.$emit("cancleOpen", false)
            this.$refs[formName].resetFields()
        },
    },
}
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
/deep/.avatar-uploader-icon {
    width: 148px;
    height: 148px;
    line-height: 148px;
}
</style>